import React, { useState, useEffect, lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import ErrorBoundary from "components/shared-components/ErrorBoundary";
import { useSelector } from "react-redux";
import { getPermissionListState } from "redux/reducers/permissions";
export const AppViews = () => {
  const [permission, setPermissions] = useState(
    JSON.parse(localStorage.getItem("permissions"))
  );
  const data = useSelector(getPermissionListState);
  useEffect(() => {
    setPermissions(JSON.parse(localStorage.getItem("permissions")));
  }, [data]);
  let checkPermissions = (checkValue) => {
    if (permission?.some((e) => e.code === checkValue)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading cover="content" />}>
        <Switch>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/manage-broker`}
            component={lazy(() => import(`./broker`))}
            hasAccesssToRoute={checkPermissions("BROKER")}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/bug-tracker`}
            component={lazy(() => import(`./bug-tracker`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
           <GuardedRoute
            path={`${APP_PREFIX_PATH}/dsr`}
            component={lazy(() => import(`./daily-sales-report`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/manage-user`}
            component={lazy(() => import(`./manage-user`))}
            hasAccesssToRoute={checkPermissions("MANAGE_USER")}
          ></GuardedRoute>

          <GuardedRoute
            path={`${APP_PREFIX_PATH}/manage-roles`}
            component={lazy(() => import(`./manage-roles`))}
            hasAccesssToRoute={checkPermissions("MANAGE_ROLES")}
          ></GuardedRoute>

          <GuardedRoute
            path={`${APP_PREFIX_PATH}/manage-location`}
            component={lazy(() => import(`./manage-location`))}
            hasAccesssToRoute={checkPermissions("MANAGE_LOCATION")}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/master-suite`}
            component={lazy(() => import(`./master-suite`))}
            hasAccesssToRoute={checkPermissions("VIEW_SUITES")}
          ></GuardedRoute>
          
          <Route
            path={`${APP_PREFIX_PATH}/property`}
            component={lazy(() => import(`./manage-property`))}
          />
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/client`}
            component={lazy(() => import(`./client-data`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/lead`}
            component={lazy(() => import(`./lead-report`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/marketing`}
            component={lazy(() => import(`./marketing`))}
            hasAccesssToRoute={
              checkPermissions("MARKETING_LEAD_LIST") || checkPermissions("MARKETING")
            }
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/salespipeline`}
            component={lazy(() => import(`./sales-pipeline`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/analytics`}
            component={lazy(() => import(`./analytics`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <GuardedRoute
            path={`${APP_PREFIX_PATH}/Operations`}
            component={lazy(() => import(`./Operations`))}
            hasAccesssToRoute={true}
          ></GuardedRoute>
          <Route
            path={`${APP_PREFIX_PATH}/signedagreement`}
            component={lazy(() => import(`./signed-agreement`))}
          />
          {/* <Route
            path={`${APP_PREFIX_PATH}/home`}
            component={lazy(() => import(`./home`))}
          /> */}
          <Route
            path={`${APP_PREFIX_PATH}/home_new`}
            component={lazy(() => import(`./home_new`))}
          />
          <Route
            path={`${APP_PREFIX_PATH}/document`}
            component={lazy(() => import(`./document`))}
          />
          <Route
            path={`${APP_PREFIX_PATH}/occupancy-tracker`}
            component={lazy(() => import(`./occupancy-tracker`))}
          />
          <Route
            path={`${APP_PREFIX_PATH}/office-booking`}
            component={lazy(() => import(`./office-booking`))}
          />

          {/* comment below route when acclgl module is not required */}
          <Route
            path={`${APP_PREFIX_PATH}/acc-lgl`}
            component={lazy(() => import(`./acclgl`))}
          />
          <Redirect
            from={`${APP_PREFIX_PATH}`}
            to={`${APP_PREFIX_PATH}/home_new`}
          />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

const GuardedRoute = ({ hasAccesssToRoute, ...rest }) =>
  hasAccesssToRoute ? (
    <Route {...rest} />
  ) : (
    <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home_new`} />
  );
export default React.memo(AppViews);
